// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMyStoneBackpack_container__C9zr\\+ {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.SideMyStoneBackpack_main__OzhHx {
    width: 100%;
    height: 100%;
}

.SideMyStoneBackpack_title_item__HdUzR {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 40px;
    padding-left: 10px;
    margin-bottom: 5px;
    cursor: pointer;
    border-radius: 6px;
    -webkit-user-select: none;
            user-select: none;
}

.SideMyStoneBackpack_title_item__HdUzR:hover {
    background-color: rgba(255, 255, 255, 0.15);
}

.SideMyStoneBackpack_collapsibleContent__604xD {
    overflow: hidden;
    transition: max-height 0.2s ease-in-out;
}

.SideMyStoneBackpack_item_collapsed__7C7n3 {
    max-height: 0;
}

.SideMyStoneBackpack_item_expanded__uyBxy {
    max-height: 300px;
}

.SideMyStoneBackpack_expert_butn_box__nWxfW {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 40px);
    height: 100%;
    cursor: pointer;
}

.SideMyStoneBackpack_img__LMnbb {
    width: 24px;
    height: 24px;
    margin-right: 6px;
}

.SideMyStoneBackpack_text__RJe-K {
    width: calc(100% - 30px - 12px);
    color: #e7e7e7;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.SideMyStoneBackpack_shrink_box__Qeu3- {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
}

.SideMyStoneBackpack_shrink_img__SgMUu {
    width: 11px;
    height: 6px;
}

.SideMyStoneBackpack_model_list__YdvnA {
    display: grid;
    grid-template-columns: repeat(5, 1fr); /* 4列，等宽 */
    grid-template-rows: repeat(2, auto); /* 2行，自动高度 */
    gap: 8px 10px; /* 上下间距8px，左右间距16px */
    padding: 10px 15px;
    width: 100%;
    height: 103px;
    box-sizing: border-box;
}

.SideMyStoneBackpack_item__4S8is {
    width: 35px;
    height: 35px;
    border: 1px solid #55575c;
    border-radius: 6px;
    background-color: #32353a;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.SideMyStoneBackpack_item_plus__3fMgQ {
    border-color: #c1c1c1;
    transition: background-color .2s ease;
}

.SideMyStoneBackpack_item_plus__3fMgQ:hover {
    background-color: #55575c;
}

.SideMyStoneBackpack_item_plus__3fMgQ:active {
    background-color: #32353a;
}

.SideMyStoneBackpack_item_plus_img__FZUSw {

}

.SideMyStoneBackpack_item_lock__Yi7zM {
    cursor: not-allowed;
}

.SideMyStoneBackpack_item_lock_img__KIMP3 {

}

.SideMyStoneBackpack_item_active__cM2XQ {
    background-color: #fff;
}

.SideMyStoneBackpack_item_img__esEK5 {
    width: 28px;
    height: 28px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/SideMyStoneBackpack/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qCAAqC,EAAE,UAAU;IACjD,mCAAmC,EAAE,YAAY;IACjD,aAAa,EAAE,qBAAqB;IACpC,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;AAEA;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.main {\n    width: 100%;\n    height: 100%;\n}\n\n.title_item {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 40px;\n    padding-left: 10px;\n    margin-bottom: 5px;\n    cursor: pointer;\n    border-radius: 6px;\n    user-select: none;\n}\n\n.title_item:hover {\n    background-color: rgba(255, 255, 255, 0.15);\n}\n\n.collapsibleContent {\n    overflow: hidden;\n    transition: max-height 0.2s ease-in-out;\n}\n\n.item_collapsed {\n    max-height: 0;\n}\n\n.item_expanded {\n    max-height: 300px;\n}\n\n.expert_butn_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: calc(100% - 40px);\n    height: 100%;\n    cursor: pointer;\n}\n\n.img {\n    width: 24px;\n    height: 24px;\n    margin-right: 6px;\n}\n\n.text {\n    width: calc(100% - 30px - 12px);\n    color: #e7e7e7;\n    font-size: 14px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.shrink_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 40px;\n    height: 40px;\n}\n\n.shrink_img {\n    width: 11px;\n    height: 6px;\n}\n\n.model_list {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr); /* 4列，等宽 */\n    grid-template-rows: repeat(2, auto); /* 2行，自动高度 */\n    gap: 8px 10px; /* 上下间距8px，左右间距16px */\n    padding: 10px 15px;\n    width: 100%;\n    height: 103px;\n    box-sizing: border-box;\n}\n\n.item {\n    width: 35px;\n    height: 35px;\n    border: 1px solid #55575c;\n    border-radius: 6px;\n    background-color: #32353a;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.item_plus {\n    border-color: #c1c1c1;\n    transition: background-color .2s ease;\n}\n\n.item_plus:hover {\n    background-color: #55575c;\n}\n\n.item_plus:active {\n    background-color: #32353a;\n}\n\n.item_plus_img {\n\n}\n\n.item_lock {\n    cursor: not-allowed;\n}\n\n.item_lock_img {\n\n}\n\n.item_active {\n    background-color: #fff;\n}\n\n.item_img {\n    width: 28px;\n    height: 28px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SideMyStoneBackpack_container__C9zr+`,
	"main": `SideMyStoneBackpack_main__OzhHx`,
	"title_item": `SideMyStoneBackpack_title_item__HdUzR`,
	"collapsibleContent": `SideMyStoneBackpack_collapsibleContent__604xD`,
	"item_collapsed": `SideMyStoneBackpack_item_collapsed__7C7n3`,
	"item_expanded": `SideMyStoneBackpack_item_expanded__uyBxy`,
	"expert_butn_box": `SideMyStoneBackpack_expert_butn_box__nWxfW`,
	"img": `SideMyStoneBackpack_img__LMnbb`,
	"text": `SideMyStoneBackpack_text__RJe-K`,
	"shrink_box": `SideMyStoneBackpack_shrink_box__Qeu3-`,
	"shrink_img": `SideMyStoneBackpack_shrink_img__SgMUu`,
	"model_list": `SideMyStoneBackpack_model_list__YdvnA`,
	"item": `SideMyStoneBackpack_item__4S8is`,
	"item_plus": `SideMyStoneBackpack_item_plus__3fMgQ`,
	"item_plus_img": `SideMyStoneBackpack_item_plus_img__FZUSw`,
	"item_lock": `SideMyStoneBackpack_item_lock__Yi7zM`,
	"item_lock_img": `SideMyStoneBackpack_item_lock_img__KIMP3`,
	"item_active": `SideMyStoneBackpack_item_active__cM2XQ`,
	"item_img": `SideMyStoneBackpack_item_img__esEK5`
};
export default ___CSS_LOADER_EXPORT___;
